import React from 'react'
import getConfig from 'next/config'

import { style } from '../../../components/Common/Index.style'

import Page from '../../../components/Page/Page'
import PageHeader from '../../../components/PageHeader/PageHeader'
import Content from '../../../components/Content/Content'
import SectionTitle from '../../../components/SectioinTitle'
import BackBtn from '../../../components/Common/BackBtn'
import BreadCrumb from '../../../components/Breadcrumbs/Breadcrumbs'

const { publicRuntimeConfig } = getConfig()
const basePath = publicRuntimeConfig.basePath

const pageTitle = 'フォトコンテスト2023 実施中 | 新潟県民だより'

const Home = () => {
  return (
    <Page title={pageTitle}>
      <PageHeader pageTitle="#新潟のコメジルシ" />
      <SectionTitle sectionTitle="フォトコンテスト2023 実施中" />
      <Content css={style.content}>
        <BreadCrumb
            lists={[
              {
                name: "HOME",
                path: "/"
              },
              {
                name: "2023秋号 No.164 目次",
                path: "/no164"
              },
              {
                name: "#新潟のコメジルシ"
              }
            ]}
          />

        <p css={style.catchTxt}>募集期限：12月31日（日）</p>
        
        <p>新潟のいいところを「※（コメジルシ）」と名付け、県民の皆さんと一緒に集め、広げている「新潟※（コメジルシ）プロジェクト」。<br />現在、新潟※（コメジルシ）プロジェクト応援団との共催によりフォトコンテストを実施中です。応援団ごとに設定された独自の募集テーマに沿った優れた作品には、「新潟米」「暖房器具」「お菓子詰め合わせ」などの豪華副賞をプレゼント。奮ってご応募ください。</p>
        
        <img
          src={`${basePath}/no164/img/4-3.png`}
          alt="コメジルシくん"
          css={style.img(250, "15px 0 0 0")}
        />
        
        <h3 css={style.subTitle01}>共催（50音順）</h3>
        <ul>
          <li>NTT東日本 新潟支店</li>
          <li>（株）クーネルワーク産直セレクトショップKITAMAE by新潟直送計画</li>
          <li>（株）コロナ</li>
          <li>生活協同組合パルシステム新潟ときめき</li>
          <li>東日本旅客鉄道（株）新潟支社</li>
          <li>（株）ブルボン</li>
          <li>（一社）南魚沼市観光協会</li>
        </ul>
        
        <h3 css={style.subTitle01}>募集テーマなど詳細はこちらから</h3>
        
        <p>
          <a
            href="https://www.pref.niigata.lg.jp/sec/kouhou/komeprophotocon2023.html"
            target="_blank"
            rel="noreferrer"
          >
            <span>フォトコンテスト実施中！</span>
          </a>
        </p>
        
        <p>
          <a
            href="https://howtoniigata.jp/komepro/"
            target="_blank"
            rel="noreferrer"
          >
            <span>公式サイト</span>
          </a>
        </p>
        
        <BackBtn href={"/no164"} />
      </Content>
    </Page>
  )
}
export default Home
